import { render, staticRenderFns } from "./AssessmentRules.vue?vue&type=template&id=8f56f16a&scoped=true"
import script from "./AssessmentRules.vue?vue&type=script&lang=js"
export * from "./AssessmentRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f56f16a",
  null
  
)

export default component.exports